import { Button, Grid, GridItem, Input, StyledHtml, Text, HStack, Box } from '@postenbring/hedwig-react';
import './banner-with-action.scss';
import { useEffect, useState } from 'react';

export const BannerWithAction = ({ backgroundColor, bannerActionBackground, contentTwo, heading, headingTwo, traceFieldPlaceholder, trackPage, traceButtonText }) => {
    
    const [traceUrl, setTraceUrl] = useState(trackPage);
    const [trackingNumber, setTrackingNumber] = useState('');
    
    useEffect(() => {
        setTraceUrl(trackPage+"/"+trackingNumber);
    }, [trackingNumber]);

    const handleTraceButtonClick = (e) => {
        e.preventDefault();
        if (trackingNumber) {
            window.location.href = traceUrl;
        }
    }

    return (
        <Box className={"action-banner action-banner-background-" + backgroundColor} style={{ backgroundImage: 'url(' + bannerActionBackground + ')' }}>
            <Grid gap="20-24" span={{ initial: 12, large: 6 }} className="hds-mb-48-64">
                <form action={trackPage}>
                    <Text variant="h2" className="hds-mb-20-24">{heading}</Text>
                    <HStack gap='8' wrap>
                        <Input
                            name="trackingNumber"
                            type="text"
                            placeholder={traceFieldPlaceholder}
                            className="action-banner-trace-input"
                            onChange={(e) => setTrackingNumber(e.target.value)}
                            value={trackingNumber}
                            autoComplete="off"
                        ></Input>
                        <Button
                            type="submit"
                            onClick={handleTraceButtonClick}
                            className="action-banner-trace-button"
                        >{traceButtonText}</Button>
                    </HStack>
                </form>
                <GridItem small="3" className="action-banner-right-content">
                    <Text variant="h2" className="hds-mb-20-24">{headingTwo}</Text>
                    <StyledHtml dangerouslySetInnerHTML={{ __html: contentTwo }}></StyledHtml>
                </GridItem>
            </Grid>
        </Box>
    )
}